// import { useEffect, useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../services/Api";
// import { authHeader } from "../../services/auth-header";

// export const useFetchProductTableData = ({ apiField, limit, sort, currentValue, search, currentPage, productType = "1" }) => {
//   const [data, setData] = useState([]);
//   const [pages, setPages] = useState(0);
//   const [totalEnteries, setTotalEnteries] = useState(0);
//   const [refreshTrigger, setRefreshTrigger] = useState(false);

//   const dateFieldsToFormat = ["createddate", "issuedate", "podate", "Mstagesdate"];

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "";
//     const [year, month, day] = dateStr.split("-");
//     return `${day}-${month}-${year}`;
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Use the new API endpoint for product type filtering
//         let url;
//         if (apiField === "product") {
//           // Map product type values to their string representations
//           const productTypeMap = {
//             "1": "Finished",
//             "2": "Raw Material",   
//             "3": "Semi Finished",
//             "4": "Services"
//           };
          
//           const productTypeString = productTypeMap[productType] || "Finished";
//           url = `${BASE_URL}${apiField}/page/ptype/${currentPage}/${limit}/${sort}/${currentValue}/${productTypeString}/${search}`;
//         } else {
//           // Original URL for other APIs
//           url = `${BASE_URL}${apiField}/page/${currentPage}/${limit}/${sort}/${currentValue}/${search}`;
//         }
        
//         const response = await axios.get(url, {
//           headers: authHeader()
//         });

//         const rawData = response.data.Index || response.data.data;

//         const formattedData = rawData.map((item) => {
//           const formattedItem = { ...item };
//           dateFieldsToFormat.forEach((field) => {
//             if (formattedItem[field]) {
//               formattedItem[field] = formatDate(formattedItem[field]);
//             }
//           });
//           return formattedItem;
//         });

//         setData(formattedData);
//         setPages(response.data.Pages);
//         setTotalEnteries(response.data.Enteries);
//       } catch (error) {
//         console.error("Error fetching table data:", error);
//       }
//     };

//     fetchData();
//   }, [apiField, limit, sort, currentValue, search, currentPage, refreshTrigger, productType]);

//   const refetch = () => {
//     setRefreshTrigger(prev => !prev);
//   };

//   return { data, pages, totalEnteries, refetch };
// };



import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

export const useFetchProductTableData = ({ 
    apiField, 
    limit, 
    sort, 
    currentValue, 
    search, 
    currentPage, 
    brandId = "1", 
    productType = "Finished" 
}) => {
  const [data, setData] = useState([]);
  const [pages, setPages] = useState(0);
  const [totalEnteries, setTotalEnteries] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const dateFieldsToFormat = ["createddate", "issuedate", "podate", "Mstagesdate"];

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url;
        if (apiField === "product") {
          // Use the new API endpoint with brand ID and product type
          url = `${BASE_URL}${apiField}/page/ptype/${currentPage}/${limit}/${sort}/${currentValue}/${brandId}/${productType}/${search}`;
        } else {
          // Original URL for other APIs
          url = `${BASE_URL}${apiField}/page/${currentPage}/${limit}/${sort}/${currentValue}/${search}`;
        }
        
        console.log("API URL:", url); // For debugging
        
        const response = await axios.get(url, {
          headers: authHeader()
        });

        const rawData = response.data.Index || response.data.data;

        const formattedData = rawData.map((item) => {
          const formattedItem = { ...item };
          dateFieldsToFormat.forEach((field) => {
            if (formattedItem[field]) {
              formattedItem[field] = formatDate(formattedItem[field]);
            }
          });
          return formattedItem;
        });

        setData(formattedData);
        setPages(response.data.Pages);
        setTotalEnteries(response.data.Enteries);
      } catch (error) {
        console.error("Error fetching table data:", error);
      }
    };

    fetchData();
  }, [apiField, limit, sort, currentValue, search, currentPage, refreshTrigger, brandId, productType]);

  const refetch = () => {
    setRefreshTrigger(prev => !prev);
  };

  return { data, pages, totalEnteries, refetch };
};